import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TSignCompanyAgreementsRequest } from "./signCompanyAgreements.schema";

export const signCompanyAgreements =
  (axios: IAxiosInstance) => async (body: TSignCompanyAgreementsRequest) => {
    const response = await axios.noRetry.post<IApiResponse<boolean>>(
      "/companies/authorization_documents",
      body,
      {
        headers: { "x-exchange-token": body.accessToken },
      }
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
